var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('r-app-bar'),_c('r-filter-drawer'),_c('v-main',[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),(_vm.user.subscription_status === 'Lapsed')?_c('r-account-deletion-alert'):_c('r-new-button'),_c('r-toast')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }